import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "The heavyweight hoodie is unreal — thick, structured, and the tiger print still looks brand new after dozens of washes.",
    name: "Marcus T.",
    location: "Manchester, UK",
  },
  {
    quote: "Ordered Monday, wearing it Friday. Printful fulfilment is fast and the oversized tee fits exactly how streetwear should.",
    name: "Jay R.",
    location: "London, UK",
  },
  {
    quote: "Finally a UK brand doing print-on-demand properly. No cheap blanks, no fading prints. Fierce Attire is the real deal.",
    name: "Sophie K.",
    location: "Glasgow, UK",
  },
];

export const TestimonialsSection = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="bg-white py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <p className="mb-3 flex items-center gap-3 font-body text-xs font-medium uppercase tracking-[0.3em] text-tiger">
            <span className="h-px w-8 bg-tiger" />Verified Buyers
          </p>
          <h2 className="font-heading text-2xl font-bold uppercase tracking-tight text-zinc-900 sm:text-3xl lg:text-4xl">
            The Pack Speaks
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={t.name}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`testimonial-${i}`}
              className={`border border-zinc-200 bg-fog p-6 transition-colors hover:border-tiger/60 sm:p-8 ${i === 1 ? "md:-translate-y-6" : ""}`}
            >
              <span className="font-display text-5xl leading-none text-tiger">"</span>
              <p className="mt-2 font-body text-sm leading-relaxed text-zinc-600">{t.quote}</p>
              <footer className="mt-6 flex items-center justify-between border-t border-zinc-200 pt-4">
                <div>
                  <p className="flex items-center gap-1.5 font-heading text-sm font-semibold text-zinc-900">
                    {t.name}
                    <BadgeCheck size={14} className="text-tiger" />
                  </p>
                  <p className="font-body text-xs text-zinc-500">{t.location}</p>
                </div>
                <div className="flex gap-0.5 text-tiger">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={12} fill="currentColor" />
                  ))}
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
